import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

import { Component, OnInit, Renderer2, Inject, PLATFORM_ID, Input, Output, ViewChild, ElementRef, HostListener, EventEmitter } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { SafePipe } from '../../pipes/safe.pipe';
import { SafehtmlPipe } from '../../pipes/safehtml.pipe';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-carousal-page',
  standalone:true,
  imports:[CommonModule,CarouselModule,RouterModule, SafehtmlPipe,SafePipe,TruncatePipe],
  templateUrl: './carousal-page.component.html',
  styleUrl: './carousal-page.component.scss'
})
export class CarousalPageComponent implements OnInit {
  constructor(private renderer: Renderer2, public utils: UtilsService,@Inject(DOCUMENT) private _document: Document,
  private router:Router,private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object) { }
  @Input() genericCarousel!: boolean;
  @Input('isProductCarousel') isProductCarousel!: boolean;
  @Input('isCategoryCarousel') isCategoryCarousel!: boolean;
  @Input('isPDPCarousel') isPDPCarousel!: boolean;
  @Input('isOurLeaderCarousel') isOurLeaderCarousel!: boolean;
  @Input('frequentlyBought') frequentlyBought!: boolean;
  @Input('carouselSlideData') carouselSlideData: any;
  @Input() centered!: boolean;
  @Output() imageClicked = new EventEmitter<{}>();
  @Output() emitValue = new EventEmitter<{}>();
  @Output() catClicked = new EventEmitter<{}>();
  @ViewChild('carousel') carousel!: ElementRef;
  @Input('isEshop') isEshop!: boolean;

  customOptionsForOurLeaderSection: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    navText: ['', ''],
    stagePadding: 50,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1100: {
        items: 4
      },
    },
  };
  environment: any = environment;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    navText: ['', ''],
    stagePadding: 50,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3
      },
    },
  };
  genericOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    autoplay: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    stagePadding: 50,
    margin: 25,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      575: {
        items: 2
      },
      768: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        items: 4
      },
    },
  };
  achievementData:any = [{
    image: environment.blobUrl+'/assets/images/career/details-image.webp',
    title: 'Market Penetration Leadership Award',
    description: 'Ever witnessed unusual heating of InverterBattery at home? Although most  ...'
  },
  {
    image:  environment.blobUrl+'/assets/images/career/details-image.webp',
    title: 'Market Penetration Leadership Award',
    description: 'Ever witnessed unusual heating of InverterBattery at home? Although most  ...'
  }
  ];
  actualSchemaValue:any;
  script:any;
  structuredData!: SafeHtml;
  ngOnInit(): void {
    this.achievementData = this.carouselSlideData && this.carouselSlideData.length ? this.carouselSlideData : this.achievementData;
    if (this.achievementData && this.achievementData.length == 1) {
      this.genericOptions.margin = 0;
      this.genericOptions.nav = false;
      this.genericOptions.autoWidth = true;
      this.genericOptions.responsive = {
        0: {
          items: 1
        }
      }
    }
    if(this.carouselSlideData != '' && this.carouselSlideData != undefined && this.carouselSlideData != null) {
      this.carouselSlideData.forEach((ele:any) => {
        if(ele && (ele.embededLink || ele.videoTitle)){
          this.addVideoSchema(this.carouselSlideData);
        }else{}
      })
    }
  }

  @HostListener('window:resize', ['$event'])
  screenWidth() {
    this.setOwlPrevPosition();
  }

  ngAfterViewInit() {
    this.setOwlPrevPosition();
  }

  setOwlPrevPosition() {
    if (this.carousel && this.carousel.nativeElement) {
      let dotsWidth = this.carousel.nativeElement.getElementsByClassName('owl-dots')[0].clientWidth;
      let prev = this.carousel.nativeElement.getElementsByClassName('owl-prev')[0];
      this.renderer.setStyle(prev, 'right', dotsWidth + 35 + 'px');
    }
  }

  onImageClick(data: any) {
    this.imageClicked.emit(data);
  }

  getProductLink(data: any, isPdpPage?: boolean) {
    let url = ''
    if (isPdpPage) {
      let name = this.utils.createNameForUrl(data.productName ? data.productName : '');
      url = `/product/${name}`;
    }
    else {
      if (this.isCategoryCarousel) {
        let name = this.utils.createNameForUrl(data.description ? data.description : '')
        //url = `/product-listing/shop-now/${name}/${data.productGuid}`
        url = `/product-listing/shop-now/${name}`
      }
      else {
        let name = this.utils.createNameForUrl(data.description ? data.description : '')
        url = `/product/${name}`;
      }
    }
    return url;
  }

  onValueEmit(data: any, productName: any) {
    this.emitValue.emit({ productGuidId: data, productName: productName })
  }

  onCatClick() {
    this.catClicked.emit(true);
  }
  async callSchema(){
    this.actualSchemaValue = await this.addVideoSchema(this.carouselSlideData);
  }
  addVideoSchema(data:any){
    const BreadcrumbList :any = [];
    // if (isPlatformBrowser(this.platformId)) {
      data?.forEach((item: any) => {
        const listItem = {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": item?.videoTitle,
          "description": "Presenting Eco Volt+ 1550 Power packed 1400VA Inverter - a Inverter that runs heavy loads with a single battery. Ideal for the urban areas where the power cut duration is less than 2 hours and you want to run more load on a single battery. This result in saving space as well as cost.",
          "thumbnailUrl": item?.embededLink,
          "uploadDate": "2020-05-05",
          "duration": "PT1M28S",
          "embedUrl": item?.embededLink,
          "potentialAction": {
            "@type": "SeekToAction",
            "target": `${item?.embededLink}={seek_to_second_number}`,
            "startOffset-input": "required name=seek_to_second_number"
          }


        };
          BreadcrumbList.push(listItem);

      });
    this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
        <script type="application/ld+json">
          ${JSON.stringify(BreadcrumbList)}
        </script>
      `);
    // }

  }
}